// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"77":"540d6871","641":"1128ef1f"}[chunkId] + ".js";
};